import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import DoctorsPage from "./features/patient-panel";
import DoctorDetails from "./features/patient-panel/doctor-details";
import AppointmentPage from "./features/patient-panel/appointment";
import ConfirmAppointment from "./features/patient-panel/confirm-appointment";
import VerifyPatient from "./features/patient-panel/verify-patient";
import AddPatient from "./features/patient-panel/add-patient";
import AddHealthRecords from "./features/patient-panel/add-health-records";

import { Toaster } from "./components/ui/toaster";
import { AuthProvider } from "./contexts/auth-context";
import Prescriptions from "./features/patient-panel/prescriptions";
import { AppointmentDataProvider } from "./contexts/appointment-data-context";
import DoctorsList from "./features/patient-panel/doctor-list";
import Appointment from "./features/patient-panel/appointment-details";
import { ErrorBoundary } from "react-error-boundary";
import ErrFallback from "./components/err-fallback";
import RecordPrescriptions from "./features/patient-panel/record-prescriptions";
import PatientProfile from "./features/patient-panel/PatientProfile";
import PatientCareLanding from "./components/patient-care-landing";
import TermsandConditions from "./components/term-comdition";
import PrivacyPolicy from "./components/privacy-policy";

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: (
        <ErrorBoundary FallbackComponent={ErrFallback}>
          <PatientCareLanding />
        </ErrorBoundary>
      ),
    },
    {
      path: "/terms-and-conditions",
      element: (
        <ErrorBoundary FallbackComponent={ErrFallback}>
          <TermsandConditions />
        </ErrorBoundary>
      ),
    },
    {
      path: "/privacy-policy",
      element: (
        <ErrorBoundary FallbackComponent={ErrFallback}>
          <PrivacyPolicy />
        </ErrorBoundary>
      ),
    },
    {
      path: "/doctors",
      element: (
        <ErrorBoundary FallbackComponent={ErrFallback}>
          <DoctorsPage />
        </ErrorBoundary>
      ),
    },
    {
      path: "/patient-profile/:patientId",
      element: (
        <ErrorBoundary FallbackComponent={ErrFallback}>
          <PatientProfile />
        </ErrorBoundary>
      ),
    },
    {
      path: "/doctors-list",
      element: <DoctorsList />,
    },
    {
      path: "/visit-prescriptions/:professionalId",
      element: <Prescriptions />,
    },

    {
      // Route for doctor details without city
      path: "/doctors/:name-:specialty-:professionalId",
      element: <DoctorDetails />,
    },
    {
      // Keep existing route if needed for other purposes
      path: "/doctors/:professionalId",
      element: <DoctorDetails />,
    },
    {
      path: "/doctors/:professionalId/appointment",
      element: <AppointmentPage />,
    },
    {
      path: "/verify-patient",
      element: <VerifyPatient />,
    },
    {
      path: "/add-patient",
      element: <AddPatient />,
    },
    {
      path: "/health-records/add",
      element: <AddHealthRecords />,
    },
    {
      path: "/health-records/:recordId",
      element: <RecordPrescriptions />,
    },
    {
      path: "/doctors/:professionalId/appointment/confirm",
      element: <ConfirmAppointment />,
    },
    {
      path: "/appointment/:id",
      element: <Appointment />,
    },
    
  ],
  {
    basename: "/care",
  },
);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <ErrorBoundary
      FallbackComponent={ErrFallback}
      onReset={() => window.location.reload()}
    >
      <QueryClientProvider client={queryClient}>
        <Toaster />
        <AuthProvider>
          <AppointmentDataProvider>
            <RouterProvider router={router} />
          </AppointmentDataProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);